<div class="loadingOverlay" *ngIf='showLoadingOverlay | async'>
    <p style="text-align: center;" [innerHTML]='loadingOverlayMessage | async'></p><img src="/assets/img/shared/loading-animation.gif" class="ajax-loader" />
</div>
<app-toasts-container aria-live="polite" aria-atomic="true"></app-toasts-container>
<app-video-modal-container aria-live="polite" aria-modal="true"></app-video-modal-container>
<app-news-banner></app-news-banner>

<div class="bg-white">
    <router-outlet></router-outlet>
</div>